export enum AppliancesPermissions {
  GET_APPLIANCES = 'appliances.getAppliances',
  MANAGE_APPLIANCES = 'appliances.manageAppliances',
}
